import cn from 'classnames';
import { Button } from 'components/UtilElements';
import { AuthAction, AuthActions } from 'containers/AuthStateManager';
import { AuthScreens } from 'globals/constants';

interface SsoLoginProps {
  setAuthState(action: AuthAction): void;
}

const SsoAuthentication = ({ setAuthState }: SsoLoginProps) => {
  const handleSsoLogin = () => {
    setAuthState({
      type: AuthActions.SSO_LOGIN,
      payload: AuthScreens.SSO_LOGIN,
    });
  };
  return (
    <>
      <h2 className='auth__title'>SSO Authentication</h2>
      <div className='auth__panel'>
        <p className='auth__message'> Please provide your institutional credentials to continue logging in</p>
        <div className={cn('auth__action-container')}>
          <Button type='ghost' selector={cn('btn-primary', 'auth__action')} onRipple={handleSsoLogin}>
            Log in using SSO
          </Button>
        </div>
      </div>
    </>
  );
};

export default SsoAuthentication;
